import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import logo from './logo.svg';
// import { I18nProvider } from '@lingui/react';
import { BackTop, Space, notification } from 'antd';
import Routes from 'routes';
import { fetchCurrentUser, getUser } from 'actions/user';
import { useDispatch } from 'react-redux';
import { addUserAction, removeUserAction } from 'redux/actions/user';
import './styles/index.css';
import { initConfig, country } from 'config';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { WarningOutlined } from '@ant-design/icons';
// import catalogID from 'locales/id/messages.js';
// import catalogEN from 'locales/en/messages.js';

// const catalogMap = { id: catalogID, en: catalogEN };
const i18n = localStorage.getItem('i18n') || 'en';
initConfig();

const UNAUTHORIZED = 401;
let BLOCK_MULTIPLE = true;

function App() {
	const [language, setLanguage] = React.useState(i18n);
	// const [catalogs, setCatalogs] = React.useState(catalogMap);

	const dispatch = useDispatch();

	const user = useSelector((state) => state.user.user);

	axios.interceptors.response.use(
		(response) => response,
		(error) => {
			const status = error?.response?.status;
			if (status === UNAUTHORIZED && BLOCK_MULTIPLE) {
				notification.open({
					message: 'Session Expired!',
					description: 'Your Session has expired. Please login to continue.',
					icon: <WarningOutlined style={{ color: '#e9c510' }} />
				});
				BLOCK_MULTIPLE = false;
				setTimeout(() => {
					localStorage.removeItem('user');
					window.location.reload();
				}, 2000);
			}
			return Promise.reject(error);
		}
	);

	React.useEffect(() => {
		const storedUser = getUser();
		if (storedUser) {
			fetchCurrentUser()
				.then((user) => {
					// console.log('user fetched', user);
					dispatch(addUserAction(user));
				})
				.catch((err) => console.log(err));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	React.useEffect(() => {
		initConfig();
	}, [user]);

	return (
		<div className="main-wrapper">
			{/* <I18nProvider language={language} catalogs={catalogs}> */}
			<BrowserRouter>
				<BackTop />
				<Routes language={language} country={country} /> {/* This is the routes */}
			</BrowserRouter>
			{/* </I18nProvider> */}
		</div>
	);
}

export default App;
